import React from "react";
import { LaunchableErrorLayout } from "./LaunchableErrorLayout";

interface LaunchableAccessErrorProps {
  isPublic: boolean;
}

export const LaunchableAccessError: React.FC<LaunchableAccessErrorProps> = ({
  isPublic,
}) => (
  <LaunchableErrorLayout
    title="Launchable Access Error"
    description={
      isPublic
        ? "This launchable is not public."
        : "You do not have access to this launchable."
    }
  />
);
